import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const DiscoverSkeleton = ({ isDesktop }) => {
  return (
    <div style={{ padding: "0 16px", ...(isDesktop && { flex: "1 0 0" }) }}>
      <SkeletonTheme
        baseColor="#D8DBE0"
        highlightColor="#EDF1F6"
        borderRadius={"4px"}
      >
        <div style={{ marginBottom: "24px" }}>
          <Skeleton wrapper={Box} width={124} height={16} />
        </div>
        <Skeleton wrapper={Box} count={1} height={isDesktop ? 424 : 128} />
      </SkeletonTheme>
    </div>
  );
};

export default DiscoverSkeleton;
